export default "__VITE_ASSET__DXCGkXdi__"